import React from "react";
import styled from "styled-components";

const HighlightSpan = styled.span`
  background-color:rgba(93, 236, 231, 1);
  padding: 0 2px;
  border-radius: 4px;
  font-weight: 500;
`;

export const highlightText = (
  text: string,
  keyword: string
): React.ReactNode[] => {
  if (!keyword || !text) return [text];

  const regex = new RegExp(`(${keyword})`, 'gi');

  return text.split(regex).map((part, index) =>
    part.toLowerCase() === keyword.toLowerCase() ? (
      <HighlightSpan key={index}>{part}</HighlightSpan>
    ) : (
      <React.Fragment key={index}>{part}</React.Fragment>
    )
  );
};
